export const ExtensionEnum = {
  AFTER_SALES: 'AFTER_SALES',
  APPLE_TV: 'APPLE_TV',
  APPOINTMENT: 'APPOINTMENT',
  AUDIT: 'AUDIT',
  CAMERA: 'CAMERA',
  CHAT: 'CHAT',
  SALES: 'SALES',
  SELF_SERVICE: 'SELF_SERVICE',
  TRACK: 'TRACK',
  PARTS: 'PARTS',
  CAMPAIGN: 'CAMPAIGN'
} as const;

export type ExtensionEnum = typeof ExtensionEnum[keyof typeof ExtensionEnum];
